import { useMemo, useRef } from "react";
import isEqual from "lodash/isEqual";

function useStableFiles<T>(files: T[]): T[] {
    const previousRef = useRef<T[]>();

    return useMemo(() => {
        if (isEqual(previousRef.current, files)) {
            return previousRef.current ?? files;
        }
        previousRef.current = files;
        return files;
    }, [files]);
}

export default useStableFiles;
